import type { TranslationMessages } from './types';

export const version: TranslationMessages = {
  update: {
    title: 'Phiên bản mới có sẵn',
    message:
      'Một phiên bản mới của ứng dụng đã có sẵn. Vui lòng làm mới để nhận các tính năng và cải tiến mới nhất.',
    current: 'Phiên bản hiện tại',
    new: 'Phiên bản mới',
    refresh: 'Làm mới ngay',
    refreshing: 'Đang làm mới...',
    delay: 'Nhắc tôi sau',
    auto_refresh: 'Tự động làm mới sau {{countdown}} giây...',
  },
};
